import React, { useState } from 'react';
import './style.css';

function LeadsComp(props) {
  const [activeItems, setActiveItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const {
    setLeadItem, leadItem,
  } = props;

  const data = [
    {
      id: 1,
      title: 'Increase Leads',
      description: 'Increase prospects, increase interest, increase customers, expand potential customers, enhance opportunities.',
    },
    {
      id: 2,
      title: 'Increase Sales',
      description: 'Increase revenue, increase jobs, increase revenue, increase profits, increase revenue.',
    },
    {
      id: 3,
      title: 'Solve Customer Problems',
      description: 'Promptly address customer issues, ensuring satisfaction and trust.',
    },
  ];

  const handleDivClick = (id, title) => {
    if (activeItems.includes(id)) {
      setActiveItems(activeItems.filter((item) => item !== id));
      setSelectedItems(selectedItems.filter((item) => item.id !== id));
    } else {
      setActiveItems([...activeItems, id]);
      // const selectedItem = `${title}${description}`;
      const selectedItem = `${title}`;
      setLeadItem([...leadItem, selectedItem]);
    }
  };

  return (
    <>
      {data.map((item) => (
        <div
          className={`main_lead_container ${activeItems.includes(item.id) ? 'activeDiv' : ''}`}
          onClick={() => handleDivClick(item.id, item.title)}
          key={item.id}
        >
          <div>
            <p className="Increase_lead">{item.title}</p>
            <p className="save_details">{item.description}</p>
          </div>
        </div>
      ))}
    </>
  );
}

export default LeadsComp;
